import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper, Card, CardContent, Grid, IconButton, Chip } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import CallEndIcon from '@mui/icons-material/CallEnd';
import MicIcon from '@mui/icons-material/Mic';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

export default function Callbot() {
  const [isCallActive, setIsCallActive] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [callHistory, setCallHistory] = useState([
    {
      id: 1,
      number: '+1 (555) 123-4567',
      duration: '5:32',
      date: '2024-03-20',
      status: 'completed',
      transcript: 'Customer inquiry about product features...'
    },
    {
      id: 2,
      number: '+1 (555) 987-6543',
      duration: '3:15',
      date: '2024-03-19',
      status: 'completed',
      transcript: 'Support request for account access...'
    }
  ]);

  const handleStartCall = () => {
    if (phoneNumber.trim()) {
      setIsCallActive(true);
    }
  };

  const handleEndCall = () => {
    setIsCallActive(false);
    if (phoneNumber.trim()) {
      const newCall = {
        id: callHistory.length + 1,
        number: phoneNumber,
        duration: '0:00',
        date: new Date().toISOString().split('T')[0],
        status: 'completed',
        transcript: 'Call transcript will appear here...'
      };
      setCallHistory([newCall, ...callHistory]);
      setPhoneNumber('');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PhoneIcon /> Callbot
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Make a Call
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="+1 (555) 123-4567"
                  disabled={isCallActive}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                {!isCallActive ? (
                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<PhoneIcon />}
                    onClick={handleStartCall}
                    disabled={!phoneNumber.trim()}
                    sx={{ minWidth: 150 }}
                  >
                    Start Call
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="error"
                    size="large"
                    startIcon={<CallEndIcon />}
                    onClick={handleEndCall}
                    sx={{ minWidth: 150 }}
                  >
                    End Call
                  </Button>
                )}
              </Box>
              {isCallActive && (
                <Box sx={{ mt: 3, textAlign: 'center' }}>
                  <Typography variant="body1" color="text.secondary" gutterBottom>
                    Call in progress...
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                    <IconButton color="primary" size="large">
                      <MicIcon />
                    </IconButton>
                    <IconButton color="primary" size="large">
                      <VolumeUpIcon />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Settings
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                  label="AI Model"
                  defaultValue="GPT-4"
                  fullWidth
                  size="small"
                />
                <TextField
                  label="Voice Speed"
                  type="number"
                  defaultValue="1.0"
                  fullWidth
                  size="small"
                />
                <TextField
                  label="Language"
                  defaultValue="English"
                  fullWidth
                  size="small"
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Call History
              </Typography>
              {callHistory.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                  No call history yet
                </Typography>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {callHistory.map((call) => (
                    <Paper
                      key={call.id}
                      sx={{
                        p: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2
                      }}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', mb: 1 }}>
                        <Box>
                          <Typography variant="subtitle1" fontWeight={600}>
                            {call.number}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {call.date} • {call.duration}
                          </Typography>
                        </Box>
                        <Chip
                          label={call.status}
                          size="small"
                          color={call.status === 'completed' ? 'success' : 'default'}
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {call.transcript}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

